// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3OFNd","name":"Header_name__2kUrf","birthday":"Header_birthday__2qK5k","skeleton":"Header_skeleton__1MBYa"};